import { getToken } from "../../../utils/auth";
import { dev_baseUrl } from "../../../utils/var";

import { ToastContainer, toast } from 'react-toastify';

// Modified SaveLinkRecord (optional: add a flag to disable toast)
export const SaveLinkRecord = async (recordData, showToast = true) => {
  const accesstoken = getToken();

  if (accesstoken) {
    try {
      const response = await fetch(`${dev_baseUrl}/EntityLink/save`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accesstoken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(recordData),
      });
      const data = await response.json();
      console.log("showToast = " + showToast);

      if (response.ok && !data.isError) {
        if (showToast) {
          toast.success("Linked Successfully", { 
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light"
           });
        }
        return { success: true, data };
      } else {
        if (showToast) {
          toast.error(data?.message || 'Unknown Error!', { 
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light"
           });
        }
        return { success: false, data };
      }
    } catch (error) {
      console.error("Error during API call:", error);
      if (showToast) {
        toast.error('API Error', { 
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
           theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
         });
      }
      return { success: false };
    }
  } else {
    console.warn("Access token is not available.");
    return { success: false };
  }
};


export const GetEntityLinks = async (fromEntityId) => {
  const accesstoken = getToken();
  if (accesstoken) {
    try {
      const response = await fetch(`${dev_baseUrl}/EntityLink/get?fromEntityId=${fromEntityId}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${accesstoken}`,
          'Content-Type': 'application/json',
        },
      });

      const data = await response.json();
      // console.log(data)

      if (response.ok && !data.isError) {
        return data.result; // Assuming `result` is the array of linked entities
      } else {
        console.error('Server error:', data);
        return [];
      }
    } catch (error) {
      console.error('Network error:', error);
      return [];
    }
  } else {
    console.warn('Access token is not available.');
    return [];
  }
};


export const DeleteLinkRecord = async (linkid, linkedEntityId, silent="false") => {
  const accesstoken = getToken();

  if (accesstoken) {
    try {
      const recordData = {
        Id: linkid,
        linkedEntityId: linkedEntityId
      }

      // console.log(JSON.stringify(recordData))

        const response = await fetch(`${dev_baseUrl}/EntityLink/delete??Id=${linkid}&linkedEntityId=${linkedEntityId}`, {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${accesstoken}`,
            "Content-Type": "application/json",
          },
          // body: JSON.stringify(recordData),
        });

        const data = await response.json();

        // Handle the response format
        if (response.ok && !data.isError) {
          if(silent==="false"){
            toast.success("Unlinked Successfully", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: true,
              closeOnClick: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
               theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
              });
          }          
            return data;
           
        }  
        if (response.ok && data.isError && data.result) {

          // Show success message from the API response
          toast.error(data?.message || 'Unknown Error on linked records!', {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
             theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
            });
            return data.result[0];
          } else {
          // Show error message from the API response
          toast.error(data?.message || 'Unknown Error on linked records!', {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
            });
            return data;
        }
    } catch (error) {
      console.error("Error during API call:", error);
      toast.error('API Error on linked records', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
         theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
        });
        return ;
    }
  } else {

    console.warn("Access token is not available.");
  }

};


export const GetEntityFilter = async (customerID) => {
  const accesstoken = getToken();
  if (accesstoken) {
    try {
      const response = await fetch(`${dev_baseUrl}/EntityLink/getfilter?customerID=${customerID}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${accesstoken}`,
          'Content-Type': 'application/json',
        },
      });

      const data = await response.json();
       console.log(data)

      if (response.ok && !data.isError) {
        return data.result; // Assuming `result` is the array of linked entities
      } else {
        console.error('Server error:', data);
        return [];
      }
    } catch (error) {
      console.error('Network error:', error);
      return [];
    }
  } else {
    console.warn('Access token is not available.');
    return [];
  }
};

export const GetfilteredRequests = async(customerID, pageNo, recordsPerPage, requestID, entityType, status, jobSiteName, jobSiteType, serviceName, propertyAreaName, propertyAreaType, userName, tagName) => {
  const accesstoken = getToken();
  if (accesstoken) {
    try {

      // console.log(`customerID=${customerID}&pageNo=${pageNo}&recordsPerPage=${recordsPerPage}&requestID=${requestID}&entityType=${entityType}&status=${status}&jobSiteName=${jobSiteName}&jobSiteType=${jobSiteType}&serviceName=${serviceName}&propertyAreaName=${propertyAreaName}&propertyAreaType=${propertyAreaType}&userName=${userName}&tagName=${tagName}`)
      
      const response = await fetch(`${dev_baseUrl}/EntityLink/getfilterRecords?customerID=${customerID}&pageNo=${pageNo}&recordsPerPage=${recordsPerPage}&requestID=${requestID}&entityType=${entityType}&status=${status}&jobSiteName=${jobSiteName}&jobSiteType=${jobSiteType}&serviceName=${serviceName}&propertyAreaName=${propertyAreaName}&propertyAreaType=${propertyAreaType}&userName=${userName}&tagName=${tagName}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${accesstoken}`,
          'Content-Type': 'application/json',
        },
      });
      
      const data = await response.json();          
      
      if (response.ok && !data.isError) {               
        
        return data;

      } else {
        console.error('Server error:', data);
        return [];
      }
    } catch (error) {
      console.error('Network error:', error);
      return [];
    }
  } else {
    console.warn('Access token is not available.');
    return { form: 'Access token is missing.' };
  }
}

